import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Bastion : liste en lecture seule des invitations privées, la plus récente en premier. */
export const InvitationsAdmin = ({ adminId }) => {
  const [invitations, setInvitations] = useState([]);
  const [total, setTotal] = useState(0);

  const charger = useCallback(() => {
    axios
      .get(`${API}/admin/invitations`, { params: { admin_id: adminId } })
      .then((r) => {
        setInvitations(r.data.invitations || []);
        setTotal(r.data.total || 0);
      })
      .catch(() => toast.error("Impossible de charger les invitations"));
  }, [adminId]);

  useEffect(charger, [charger]);

  return (
    <section className="mt-10 rounded-2xl border border-[#E5DFD5] bg-white p-6" data-testid="admin-invitations">
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-heading inline-flex items-center gap-2 text-base font-bold text-stone-900 md:text-lg">
          <Mail size={17} className="text-[#E05638]" /> Invitations privées
          <span className="rounded-full bg-[#E05638]/10 px-2.5 py-0.5 text-xs font-bold text-[#E05638]"
            data-testid="admin-invitations-total">{total}</span>
        </h2>
        <button onClick={charger} data-testid="admin-invitations-rafraichir"
          className="inline-flex items-center gap-1.5 rounded-full border border-[#E5DFD5] px-3.5 py-1.5 text-xs font-semibold text-stone-600 hover:border-stone-400">
          <RefreshCw size={13} /> Rafraîchir
        </button>
      </div>

      {invitations.length === 0 ? (
        <p className="mt-5 text-sm text-stone-500" data-testid="admin-invitations-vide">
          Aucune invitation pour le moment.
        </p>
      ) : (
        <div className="mt-5 overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="text-[11px] uppercase tracking-wider text-stone-400">
                <th className="py-2 pr-4">Reçue le</th>
                <th className="py-2 pr-4">Annonceur</th>
                <th className="py-2 pr-4">Visiteur</th>
                <th className="py-2 pr-4">WhatsApp</th>
                <th className="py-2 pr-4">Rendez-vous</th>
                <th className="py-2">Message</th>
              </tr>
            </thead>
            <tbody>
              {invitations.map((i) => (
                <tr key={i.id} className="border-t border-[#F0EBE3]" data-testid={`admin-invitation-${i.id}`}>
                  <td className="py-2.5 pr-4 text-xs text-stone-500">
                    {new Date(i.created_at).toLocaleString("fr-FR")}
                  </td>
                  <td className="py-2.5 pr-4 font-semibold text-stone-800">{i.annonceur_nom}</td>
                  <td className="py-2.5 pr-4 text-stone-700">{i.visitor_name}</td>
                  <td className="py-2.5 pr-4 text-stone-700">{i.visitor_whatsapp}</td>
                  <td className="py-2.5 pr-4 text-xs text-stone-500">{i.datetime || "à convenir"}</td>
                  <td className="py-2.5 max-w-xs truncate text-xs text-stone-500">{i.message || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default InvitationsAdmin;
